import axios from 'axios';

// const URL = 'http://localhost:4000'
const URL = 'https://roshi-chat.herokuapp.com'

export const UpdateInfo = async (form, id) => {
  const res = await axios.put(`${URL}/coach/update/${id}`, form)
  return res.data;
}

export const GetCoach = async (id) => {
  const res = await axios.get(`${URL}/coach/${id}`);
  return res.data;
}

